import React, { useState, useCallback } from 'react'
import { Layout, Tabs } from 'antd'
import HeaderNavigation from '../../components/HeaderNavigation'
import SummaryReport from '../../components/reports/summary'
import EstimateReport from '../../components/reports/estimate'
import TransportationReport from '../../components/reports/transportation'
import ProviderReport from '../../components/reports/provider'
import EstimateCategory from '../../components/reports/estimate-category'
import './style.css'

const { Content } = Layout
const { TabPane } = Tabs

const Dashboard = () => {
  const [applicationState, setApplicationState] = useState('summary')

  const onTabSelect = useCallback((key) => {
    setApplicationState(key)
  }, [])

  return (
    <Layout>
      <HeaderNavigation activeKey="3" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <Tabs onChange={onTabSelect} activeKey={applicationState}>
          <TabPane tab="Сводный отчет" key="summary">
            <SummaryReport />
          </TabPane>
          <TabPane tab="По смете" key="estimate">
            <EstimateReport />
          </TabPane>
          <TabPane tab="Отчет о доставке" key="transportation">
            <TransportationReport />
          </TabPane>
          <TabPane tab="Отчет по поставщикам" key="provider">
            <ProviderReport />
          </TabPane>{' '}
          <TabPane tab="Сопоставление со сметой" key="extimateCategory">
            <EstimateCategory />
          </TabPane>
        </Tabs>
      </Content>
    </Layout>
  )
}

export default Dashboard
